export const environment = {
  appVersion: '%APP_VERSION%',
  version: require('../../package.json').version,
  production: true,
  test: false,
  local: false,
  disableGlobalErrorModal: false,
  logErrorToConsole: true,
};
